<template>
  <div class="social-networks-selections-wrapper">
    <Row :gutter="20" v-for="(social, idx) in value" :key="idx" class="social-network-wrap padding-b-20">
      <Col :xs="24" :sm="10">
        <KSelect v-model="social.type" :optionList="social_networks" class="k-select"/>
      </Col>
      <Col :xs="24" :sm="14" style="display:flex;">
        <Input v-model="social.url" placeholder="Enter URL..." class="k-input"/>
        <div class="social-delete text-center" style="margin-left:10px;">
          <Icon type="md-trash" color="#ccc" style="border:1px solid #ccc;border-radius:50%;padding:4px;" class="clickable" @click="handleRemove(idx)"/>
        </div>
      </Col>
    </Row>
    <Button long size="small" @click="handleAdd">Add</Button>
  </div>
</template>

<script>
import KSelect from '@/components/ui/Select'

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  components: {
    KSelect
  },

  watch: {
    value: {
      handler (val) {
        this.$emit('change', val)
      },
      deep: true
    }
  },

  methods: {
    handleRemove (idx) {
      this.value.splice(idx, 1)
    },

    handleAdd () {
      this.value.push({
        type: '',
        url: ''
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.social-networks-selections-wrapper {
  .social-network-wrap:first-child {
    .social-delete {
      visibility: hidden;
    }
  }
}
</style>
